var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pigmentation-template',{attrs:{"has-hyper-pigmentation":_vm.hasHyperPigmentation,"hyperpigmentation":_vm.hyperpigmentation,"hyperpigmentation-ai-selected":_vm.hyperpigmentationAiSelected,"spot-shapes":_vm.spotShapes,"spot-shapes-ai-selected":_vm.spotShapesAiSelected,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }